<template>
  <transition name="fade">
    <div class="popup-picker" @click="show = false">
      <transition name="slide-up" @after-leave="$emit('close')">
        <div class="popup-main" v-if="show">
          <div class="popup-header">
            <span class="popup-header_title">{{title}}</span>
            <div v-if="activeListEdit" class="popup-header_right">
              <a v-if="!activeEditBtn" href="javascript:void(0);" class="popup-header_right_edit" @click.stop="editLists">編輯</a>
              <a v-else href="javascript:void(0);" class="popup-header_right_save" @click.stop="saveLists">保存</a>
            </div>
          </div>
          <div class="popup-content" v-if="list.length" :style="contentStyle">
            <div
              :key="item.id"
              v-for="item in list"
              class="popup-content_item"
              @click="selectItem(item)"
            >
              <span
                v-if="item.icon"
                class="popup-content_item--icon"
                :style="`background-image:url(${item.icon})`"
              ></span>
              <div class="popup-content_item--name" :class="item.icon ? 'has-icon' : false">
                <span class="name">{{item.name}}</span>
                <span class="more" v-if="item.more">{{item.more}}</span>
                <span class="tips" v-if="item.tips">{{item.tips}}</span>
              </div>
              <span v-if="activeEditBtn" class="popup-content_item--arrow icon-edit_del" @click.stop="delListItem(item.id)"></span>
              <span v-else class="popup-content_item--arrow icon-arrow_right"></span>
            </div>
          </div>
          <div class="popup-content_empty" v-else>暫無數據</div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PopupPicker',
  props: {
    title: {
      type: String,
      default: '請選擇儲值渠道'
    },
    list: {
      type: Array,
      default: () => []
    },
    contentStyle: {
      type: String,
      default: ''
    },
    activeListEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: false,
      activeEditBtn: false
    }
  },
  methods: {
    selectItem (item) {
      this.show = false
      this.$emit('select', item)
    },
    delListItem (keyValue) {
      this.$emit('delListItem', keyValue)
    },
    editLists () {
      this.$emit('editLists');
      this.activeEditBtn = true;
    },
    saveLists () {
      this.$emit('saveLists');
      this.activeEditBtn = false;
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.show = true
    })
  }
}
</script>

<style lang="scss" scoped>
.popup-picker {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  position: fixed;
  background: rgba($color: #000, $alpha: 0.8);
  .popup-main {
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    position: absolute;
    .popup-header {
      display: flex;
      justify-content: space-between;
      height: 20px;
      font-size: 13px;
      color: #6d6d6d;
      line-height: 20px;
      padding: 16px 16px 0;
      &_right {
        &_edit,
        &_save {
          display: inline-block;
          padding: 2px 6px;
          border-width: 1px;
          border-style: solid;
          border-radius: 4px;
          text-decoration: none;
        }
        &_edit {
          border-color: #9B9B9B;
          color: #9B9B9B;
        }
        &_save {
          border-color: #EB7C3C;
          background-color: #EB7C3C;
          color: #ffffff;
        }
      }
    }
    .popup-content {
      overflow: auto;
      cursor: pointer;
      max-height: 250px;
      padding: 0 16px 16px;
      box-sizing: border-box;
      -webkit-overflow-scrolling: touch;
      -webkit-tap-highlight-color: rgba(0,0,0,0);
      &_empty {
        padding: 16px;
        text-align: center;
      }
      &_item {
        height: 50px;
        display: flex;
        padding: 10px 0;
        line-height: 30px\9;
        align-items: center;
        box-sizing: border-box;
        justify-content: flex-start;
        border-bottom: 1px solid #ebebeb;
        &--icon {
          flex: 0 0 30px;
          text-align: center;
          width: 30px\9;
          display: inline-block\9;
          background-size: 100% 100%;
          &:after {
            content: " ";
            display: block;
            padding-bottom: 100%;
          }
        }
        &--name {
          flex: 1;
          color: #333;
          font-size: 15px;
          font-weight: 700;
          padding-left: 15px;
          position: relative;
          width: calc(100% - 54px)\9;
          display: inline-block\9;
          .name {
            min-width: 100px;
            display: inline-block;
          }
          .more {
            top: 50%;
            right: 10px;
            font-size: 12px;
            color: #e97d30;
            font-weight: 500;
            // margin-left: 20px;
            position: absolute;
            transform: translate(0, -50%);
          }
          .tips {
            top: 50%;
            right: 10px;
            width: 72px;
            height: 16px;
            color: #fff;
            font-size: 11px;
            line-height: 16px;
            text-align: center;
            position: absolute;
            background-color: #f44336;
            transform: translate(0, -50%);
          }
        }
        &--arrow {
          flex: 0 0 9px;
          margin-right: 5px;
          width: 9px\9;
          display: inline-block\9;
        }
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}
.slide-up-enter,
.slide-up-leave-to {
  transform: translate3d(0, 80%, 0);
  transform: translate(0, 80%) \9;
  opacity: 0;
}
</style>
